import { useMemo } from 'react'
import { AccountType } from '@/common/types'
import { useFetchTradingAccount } from '@/trading/tradingQueries'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { useFetchAccountDetail } from '@/account/accountQueries'
import { buildAccountSettingsDetailItems } from './accountSettingsDetails'
import type { AccountSettingsDetails } from '../types'

interface UseAccountSettingsItemsProps {
    onAddAdviserTradeConfirmation?: () => void
    onAddAdviserRegistrationAddress?: () => void
}

export function useAccountSettingsItems({
    onAddAdviserTradeConfirmation,
    onAddAdviserRegistrationAddress,
}: UseAccountSettingsItemsProps): AccountSettingsDetails {
    const account = useCurrentAccount()
    const isAdviser = account?.accountType === AccountType.ADVISER

    const { data: tradingAccount } = useFetchTradingAccount(account?.accountId ?? null, {
        enabled: Boolean(account?.accountId) && !isAdviser,
    })

    const { data: accountDetail } = useFetchAccountDetail(account?.accountId, {
        enabled: Boolean(account?.accountId) && isAdviser,
    })

    const accountSettingsDetails = useMemo(
        () =>
            buildAccountSettingsDetailItems(
                isAdviser,
                tradingAccount,
                accountDetail?.communicationPreferences?.contractNotes?.email,
                accountDetail?.postalAddress,
                onAddAdviserTradeConfirmation,
                onAddAdviserRegistrationAddress,
            ),
        [
            isAdviser,
            tradingAccount,
            accountDetail?.communicationPreferences?.contractNotes?.email,
            accountDetail?.postalAddress,
            onAddAdviserTradeConfirmation,
            onAddAdviserRegistrationAddress,
        ],
    )

    return accountSettingsDetails
}
